import PublishedModelTableTooltip from "./PublishedModelTableTooltip";
import React from "react";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Drawer from "@mui/material/Drawer";
import DrawerHeader from "../requests/shared/helpers/DrawerHeader";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import ButtonOutlined from "../requests/shared/helpers/ButtonOutlined";
import DrawerFooterContainerLarge from "../requests/shared/helpers/DrawerFooterContainerLarge";
import ButtonDelete from "../requests/shared/helpers/ButtonDelete";
import LaborDriverLocationValues from "./LaborDriverLocationValues";

function LaborDriversAttributesTable(props) {
  const default_data = {
    labor_driver_attribute: {
      store_labor_driver_attributes: [],
      uuid: null,
      value: null,
    },
    labor_driver_sales: null,
    name: "",
    uuid: "",
  };

  const [attributeLaborDrivers, setAttributeLaborDrivers] = React.useState([]);

  React.useEffect(() => {
    // Filter props.laborDrivers to include only objects with non-null labor_driver_attribute
    const filteredDrivers = props.laborDrivers.filter(
      (driver) => driver.labor_driver_attribute !== null
    );
    // Set the filtered array to attributeLaborDrivers state
    setAttributeLaborDrivers(filteredDrivers);
  }, [props.laborDrivers]);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFormAttempted(false);
  };
  const [modalData, setModalData] = React.useState(default_data);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [expandedDriverUuid, setExpandedDriverUuid] = React.useState(null);
  const [formAttempted, setFormAttempted] = React.useState(false);

  const trimmedName = String(modalData.name || "").trim();
  const rawDefaultValue = modalData.labor_driver_attribute?.value;
  const numericDefaultValue = Number(rawDefaultValue);
  const nameIsValid = trimmedName.length > 0 && trimmedName.length <= 128;
  const valueIsValid =
    rawDefaultValue !== "" &&
    rawDefaultValue !== null &&
    rawDefaultValue !== undefined &&
    Number.isFinite(numericDefaultValue);
  const formIsValid = nameIsValid && valueIsValid;

  const toggleExpandedDriver = (driverUuid) => {
    setExpandedDriverUuid((current) =>
      String(current) === String(driverUuid) ? null : driverUuid
    );
  };

  const openCompanyEditor = (attributeLaborDriver) => {
    setModalData(attributeLaborDriver);
    setModalEdit(true);
    handleOpen();
  };

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "value" || name === "uuid") {
      setModalData((prevModalData) => ({
        ...prevModalData,
        labor_driver_attribute: {
          ...prevModalData.labor_driver_attribute,
          [name]: value,
        },
      }));
    } else {
      setModalData((prevModalData) => ({
        ...prevModalData,
        [name]: value,
      }));
    }
  }

  async function handleSubmit() {
    setFormAttempted(true);
    if (!formIsValid) return;
    await props.post_labor_driver_company_attribute(
      modalData.labor_driver_attribute.uuid,
      trimmedName,
      numericDefaultValue
    );
    handleClose();
  }

  // console.log("MODAL DATA", modalData)

  return (
    <>
      <div className="px-6 pb-6 pt-7 sm:px-4">
        <div className="flex items-start justify-between gap-6 md:flex-col md:items-stretch">
          <div className="min-w-0">
            <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
              <h3 className="text-xl font-semibold text-slate-900">
                Attributes
              </h3>
              <span className="text-sm text-slate-500">
                {attributeLaborDrivers.length} configured
              </span>
            </div>
            <p className="mt-1 max-w-3xl text-sm leading-6 text-slate-500">
              Define numeric company defaults and review the locations that use
              a different value.
            </p>
          </div>
          {!props.readOnly ? (
            <button
              type="button"
              className="inline-flex h-10 shrink-0 items-center rounded-lg bg-violet-700 px-4 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-violet-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-600 focus-visible:ring-offset-2"
              onClick={() => {
                setModalData(default_data);
                setModalEdit(false);
                setFormAttempted(false);
                handleOpen();
              }}
            >
              <AddIcon className="mr-1.5" sx={{ fontSize: 19 }} />
              Add attribute
            </button>
          ) : null}
        </div>
        <div className="mt-5 overflow-hidden rounded-xl border border-slate-200 bg-white">
          <div className="overflow-x-auto">
            <PublishedModelTableTooltip readOnly={props.readOnly}>
            <table className="min-w-[680px] w-full table-fixed">
                  <thead className="border-b border-slate-200 bg-slate-50">
                    <tr>
                      <th
                        scope="col"
                        className="w-[38%] px-5 py-3 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-500"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="w-[24%] px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-500"
                      >
                        Company default
                      </th>
                      <th scope="col" className="w-[30%] px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                        Location values
                      </th>
                      <th scope="col" className="w-[8%] px-4 py-3">
                        <span className="sr-only">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200">
                    {attributeLaborDrivers?.map((attributeLaborDriver) => {
                      const locationValues =
                        props.laborDriverStoreAttributes?.find(
                          (item) =>
                            String(item.uuid) ===
                            String(attributeLaborDriver.uuid)
                        ) || null;
                      const isExpanded =
                        String(expandedDriverUuid) ===
                        String(attributeLaborDriver.uuid);
                      const overrideCount =
                        locationValues?.labor_driver_attributes_all_stores?.filter(
                          (storeValue) => storeValue.is_override
                        ).length || 0;
                      const locationValuesId = `attribute-${attributeLaborDriver.uuid}-locations`;

                      return (
                      <React.Fragment key={attributeLaborDriver.uuid}>
                        <tr className="group transition-colors hover:bg-violet-50/50">
                          <td className="px-5 py-4 text-sm">
                            <p className="truncate font-semibold text-slate-900" title={attributeLaborDriver.name}>
                              {attributeLaborDriver.name}
                            </p>
                          </td>
                          <td className="px-4 py-4 text-sm">
                            <span className="inline-flex rounded-md bg-slate-100 px-2.5 py-1 font-semibold text-slate-700">
                              {attributeLaborDriver.labor_driver_attribute.value}
                            </span>
                          </td>
                          <td className="px-4 py-4 text-sm">
                            <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${overrideCount > 0 ? "bg-violet-50 text-violet-700" : "bg-slate-100 text-slate-600"}`}>
                              {overrideCount} {overrideCount === 1 ? "override" : "overrides"}
                            </span>
                          </td>
                          <td className="px-4 py-4 text-right text-sm font-medium">
                            <div className="flex items-center justify-end gap-1 text-slate-500">
                              {!props.readOnly ? (
                                <Tooltip title="Edit company default">
                                  <button
                                    type="button"
                                    aria-label={`Edit ${attributeLaborDriver.name} company default`}
                                    className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-slate-500 hover:bg-white hover:text-violet-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-600"
                                    onClick={() => openCompanyEditor(attributeLaborDriver)}
                                  >
                                    <EditOutlinedIcon fontSize="small" />
                                  </button>
                                </Tooltip>
                              ) : null}
                              <Tooltip title={isExpanded ? "Hide location values" : "Show location values"}>
                                <button
                                  type="button"
                                  aria-label={`${isExpanded ? "Hide" : "Show"} location values for ${attributeLaborDriver.name}`}
                                  aria-expanded={isExpanded}
                                  aria-controls={locationValuesId}
                                  className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-slate-500 hover:bg-white hover:text-violet-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-600"
                                  onClick={() => toggleExpandedDriver(attributeLaborDriver.uuid)}
                                >
                                  <ChevronRightIcon
                                    className={`transition-transform ${
                                      isExpanded ? "rotate-90" : ""
                                    }`}
                                  />
                                </button>
                              </Tooltip>
                            </div>
                          </td>
                        </tr>
                        {isExpanded ? (
                          <tr id={locationValuesId} className="bg-slate-50">
                            <td colSpan={4} className="p-0">
                              <LaborDriverLocationValues
                                type="attribute"
                                item={locationValues}
                                readOnly={props.readOnly}
                                onSave={
                                  props.post_labor_driver_store_attribute
                                }
                              />
                            </td>
                          </tr>
                        ) : null}
                      </React.Fragment>
                      );
                    })}
                    {!attributeLaborDrivers.length ? (
                      <tr>
                        <td colSpan={4} className="px-6 py-12 text-center text-sm text-slate-500">
                          No attributes yet. Add one to use a numeric company or
                          location value in labor standards.
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
            </table>
            </PublishedModelTableTooltip>
          </div>
        </div>
      </div>
      <Drawer open={open} anchor="right" onClose={handleClose}>
        <div className="w-[450px] h-full">
          <div className="max-h-screen overflow-auto">
            <DrawerHeader
              title={
                modalEdit ? "Edit Attribute Driver" : "Add Attribute Driver"
              }
              onClose={handleClose}
            />
            <div className="w-full px-6">
              <div className="mt-5">
                <p className="text-sm text-slate-500">Name</p>
                <div className="mt-1">
                  <TextField
                    placeholder="Driver name"
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="name"
                    value={modalData.name}
                    onChange={handleChange}
                    onBlur={() => setFormAttempted(true)}
                    error={formAttempted && !nameIsValid}
                    helperText={
                      formAttempted && !nameIsValid
                        ? "Enter a name up to 128 characters."
                        : ""
                    }
                    inputProps={{ maxLength: 128 }}
                    InputProps={{
                      sx: {
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "5px",
                        height: "45px",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6d28d9",
                        },
                      },
                    }}
                  />
                </div>
              </div>
              <div className="mt-5">
                <p className="text-sm text-slate-500">Default value</p>
                <div className="mt-1">
                  <TextField
                    placeholder="1"
                    fullWidth
                    variant="outlined"
                    size="small"
                    type="number"
                    name="value"
                    value={modalData.labor_driver_attribute?.value ?? ""}
                    onChange={handleChange}
                    onBlur={() => setFormAttempted(true)}
                    error={formAttempted && !valueIsValid}
                    helperText={
                      formAttempted && !valueIsValid
                        ? "Enter a valid numeric default."
                        : ""
                    }
                    inputProps={{ step: "any" }}
                    InputProps={{
                      sx: {
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "5px",
                        height: "45px",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6d28d9",
                        },
                      },
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="h-[200px]"></div>
          </div>
          <div>
            <DrawerFooterContainerLarge>
              <div className="w-full">
                <LoadingButton
                  variant="contained"
                  // loading={savingLoading}
                  loadingPosition="end"
                  endIcon={<SaveIcon />}
                  disabled={!formIsValid}
                  onClick={() => handleSubmit()}
                  sx={{
                    width: "100%",
                    textTransform: "none",
                    borderRadius: "12px",
                    paddingY: "14px",
                    backgroundColor: "#6d28d9",
                    "&:hover": {
                      backgroundColor: "#5b21b6",
                    },
                    fontSize: "16px",
                  }}
                >
                  {modalEdit ? "Save Changes" : "Save Attribute Driver"}
                </LoadingButton>
              </div>
              <div className="w-full mt-3">
                {modalEdit ? (
                  <ButtonDelete
                    text="Delete"
                    onClick={async () => {
                      try {
                        await props.delete_labor_driver(modalData.uuid);
                        handleClose();
                      } catch (error) {
                        console.error("Error deleting labor driver:", error);
                      }
                    }}
                  />
                ) : (
                  <ButtonOutlined text="Cancel" onClick={() => handleClose()} />
                )}
              </div>
            </DrawerFooterContainerLarge>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default LaborDriversAttributesTable;
